import apiUrl from './api';
import { postWithAuth } from '@/lib/httpAdapter';

export interface BulkAddUsersToTeamRequest {
  UserUUIDs: string[];
  OrgUUID: string;
  TeamUUID: string;
}

export interface BulkAddUsersToTeamResponse {
  updatedCount: number;
  error: string | null;
}

export const bulkAddUsersToTeam = async (
  request: BulkAddUsersToTeamRequest
): Promise<BulkAddUsersToTeamResponse> => {
  const url = `${apiUrl}bulkAddUsersToTeam/`;
  try {
    const response = await postWithAuth(url, request);
    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }
    const data = await response.json();
    if (typeof data === 'string') {
      return JSON.parse(data);
    }
    return {
      updatedCount: data.updatedCount ?? data.UpdatedCount ?? 0,
      error: data.error ?? data.Error ?? null,
    };
  } catch (error) {
    console.error('Error bulk adding users to team:', error);
    throw error;
  }
};

export const addUserToTeam = async (teamId: string, userId: string) => {
  const url = `${apiUrl}addUserToTeam/`;
  const requestBody = {
    TeamUUID: teamId,
    UserUUID: userId,
  };
  try {
    const response = await postWithAuth(url, requestBody);
    const rawData = await response.json().catch(() => null);
    const data = typeof rawData === 'string' ? JSON.parse(rawData) : rawData;

    // A 400 here carries the reason in the body: read it before throwing
    // so callers can show it instead of a generic status-code message.
    if (!response.ok) {
      throw new Error(
        data?.Error || data?.error || `HTTP error! status: ${response.status}`
      );
    }

    return data;
  } catch (error) {
    console.error('Error adding user to team:', error);
    throw error;
  }
};

export const removeUserFromTeam = async (teamId: string, userId: string) => {
  const url = `${apiUrl}removeUserFromTeam/`;
  const requestBody = {
    TeamUUID: teamId,
    UserUUID: userId,
  };
  try {
    const response = await postWithAuth(url, requestBody);
    const rawData = await response.json().catch(() => null);
    const data = typeof rawData === 'string' ? JSON.parse(rawData) : rawData;

    // Same as addUserToTeam: surface the backend's error message rather than
    // swallowing it.
    if (!response.ok) {
      throw new Error(
        data?.Error || data?.error || `HTTP error! status: ${response.status}`
      );
    }

    return data;
  } catch (error) {
    console.error('Error removing user from team:', error);
    throw error;
  }
};
